import { inject, provide, type InjectionKey } from 'vue';
import type { EchoKey } from '../types';

export interface FormGeneratorContext {
  getValues: () => any;
  updateModelValue: (
    key: EchoKey,
    value: any,
    options?: {
      triggerFieldOnChange?: boolean; // 如果 field 有 onChange，判定是否触发，默认触发
    },
  ) => void;
  assignModelValue: (
    model: any,
    options?: {
      triggerFieldOnChange?: boolean; // 如果 model 内的 field 有 onChange，判定是否触发，默认触发
    },
  ) => void;
  triggerFieldChange: (key: EchoKey, value: any) => void;
  triggerWriteDone: (payload: { key: EchoKey; val: any }) => void;
  addEffect: (
    key: EchoKey,
    effectKeys: string | string[],
    fn: (effectVal: any) => void,
  ) => void;
  rmEffect: (key: EchoKey) => void;
  addFieldChangeFn: (key: EchoKey, fn: (val: any) => void) => void;
  rmFieldChangeFn: (key: EchoKey) => void;
}

const ProvideContextKey = Symbol('FormGeneratorContext');

/**
 * @description Provider
 */
export function ProvideFormContext(context: FormGeneratorContext) {
  provide(ProvideContextKey, context);
}

/**
 * @description Injector
 */
export function InjectFormContext() {
  return inject(ProvideContextKey) as FormGeneratorContext;
}

export const FormI18nKey: InjectionKey<{
  global: { t: (key: string) => string };
}> = Symbol('form-i18n-key');
